<template>
  <div class="w-full relative z-[9999]">
    <div
      class="relative z-20 container mx-auto px-[20px] flex pt-[90px] xl:pt-[134px]"
    >
      <div
        style="animation-delay: 0.6s"
        class="animate__animated animate__fadeIn lg:max-w-[747px] max-w-[90%] flex flex-col gap-[25px]"
      >
        <h1
          class="font-bold text-white font-tertiary text-[42px] leading-[42px] sm:text-[48px] sm:leading-[52px] md:text-[72px] md:leading-[82px] lg:text-[87px] lg:leading-[92.5px]"
        >
          Objavte neobmedzené

          <span
            class="block bg-clip-text text-transparent bg-gradient-to-r from-[#6e96ff] to-[#aa6eff]"
            >IT riešenia</span
          >
        </h1>
        <p
          class="md:text-[20px] md:leading-[28px] text-[16px] leading-[24px] font-primary text-[#c9d4f0] max-w-[610px]"
        >
          Sme IT spoločnosť, ktorá využíva pokročilé technológie. Našim poslaním
          je poskytnúť svojim klientom neobmedzené možnosti v rámci IT segmentu.
        </p>
        <div
          class="lg:pt-[29px] md:pt-[22px] pt-[18px] flex items-center gap-[20px] text-[20px] leading-[24px]"
        >
          <button
            class="md:text-[20px] md:leading-[24.4px] text-[16px] leading-[24px] font-semibold font-primary bg-gradient-to-r from-[#6015FF] via-[#6015FF] to-[#7958EF] md:w-[244px] w-[200px] text-center md:py-[15px] py-[12px] opacity-90 rounded-[60px] text-white transform scale-100 hover:scale-105 hover:from-[#7958EF] hover:via-[#7958EF] hover:to-[#6015FF] transition-all ease-in-out duration-300"
          >
            Mám záujem
          </button>
          <div
            class="group relative px-[2px] py-[2px] md:w-[244px] w-[200px] transform scale-100 hover:scale-105 transition-all ease-in-out duration-300"
          >
            <div
              class="absolute inset-0 bg-gradient-to-r from-[#5E16F9] to-[#7958EF] opacity-90 rounded-[70px]"
            ></div>

            <button
              class="block text-center relative py-[12px] md:py-[14px] px-[18.5px] rounded-[70px] w-full md:text-[20px] md:leading-[24.4px] text-[16px] leading-[24px] font-semibold font-primary bg-[#131429] text-white"
            >
              Naše služby
            </button>
          </div>
        </div>
      </div>
      <div class="relative lg:block hidden">
        <div
          style="animation-delay: 0.6s"
          class="bg-transparent animate__animated animate__fadeInUp w-[630px] h-[630px] absolute top-[50px] rounded-full shadow-2xl border-t-[1px] border-t-purple-400"
        ></div>
      </div>
    </div>
    <img
      style="animation-delay: 0.8s"
      class="animate__animated animate__fadeIn z-10 absolute top-0 xl:right-0 lg:right-[-450px] right-[-100px] drop-shadow-2xl"
      alt="img"
      src="../assets/6.svg"
    />
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>